import http from './http';
import socket from './socket';

/* Transformers */

export const transformArchitecture = (architecture) => ({
  ...architecture,
  createdAt: new Date(architecture.createdAt),
});

/* Actions */

const createArchitecture = (factoryId, data, requestId, headers) =>
  http
    .post(`/factory/${factoryId}/architectures?requestId=${requestId}`, data, headers)
    .then((body) => ({
      ...body,
      item: transformArchitecture(body.item),
    }));

const deleteArchitecture = (id, headers) =>
  socket.delete(`/architectures/${id}`, undefined, headers).then((body) => ({
    ...body,
    item: transformArchitecture(body.item),
  }));

const getArchitectures = (factoryId, headers) =>
  socket.get(`/architectures/${factoryId}`, undefined, headers);

/* Event handlers */

const makeHandleArchitectureCreate = (next) => (body) => {
  next({
    ...body,
    item: transformArchitecture(body.item),
  });
};

const makeHandleArchitectureUpdate = makeHandleArchitectureCreate;

const makeHandleArchitectureDelete = makeHandleArchitectureCreate;

export default {
  createArchitecture,
  deleteArchitecture,
  getArchitectures,
  makeHandleArchitectureCreate,
  makeHandleArchitectureUpdate,
  makeHandleArchitectureDelete,
};
